import React from 'react';
import { CSpinner } from '@coreui/react';
import PropTypes from 'prop-types';

const styles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '250px',
};

const SpinnerWithContainer = (props) => {
  return (
    <div style={{ ...styles, ...props.styles }}>
      <CSpinner color="info" />
    </div>
  );
};

SpinnerWithContainer.propTypes = {
  styles: PropTypes.object,
};

export default SpinnerWithContainer;
